import { useEffect, useMemo, useState } from 'react';
import { getAllActiveProducts } from 'api';
import { useProducts } from 'store';
import { ISubscriptionOrder } from 'types';

const tabs = ['Subscription', 'Orders'] as const;

type Tabs = (typeof tabs)[number];

const usePeriodOptions = () => {
  const { products } = useProducts();
  if (!products) {
    return {
      periodOption: [],
      minMonthPrice: 0,
    };
  }
  const periodOptions: {
    title: string;
    price: string;
    fullPrice?: number;
    discount?: number;
  }[] = [
    {
      title: products[0].name,
      price: products[0].usdPrice,
    },
    {
      title: products[1].name,
      price: products[1].usdPrice,
      fullPrice: 3,
      discount: 10,
    },
    {
      title: products[2].name,
      price: products[2].usdPrice,
      fullPrice: 6,
      discount: 15,
    },
    {
      title: products[3].name,
      price: products[3].usdPrice,
      fullPrice: 12,
      discount: 20,
    },
  ];
  const minMonthPrice = products[0].usdPrice;

  return {
    periodOptions,
    minMonthPrice,
  };
};

const stub = [
  {
    title: '',
    price: 0,
    fullPrice: 149,
    discount: 10,
  },
];

type Period = (typeof stub)[number]['title'];

const BasicPlan = [
  'Secure Bitcoin Vault for multiple members',
  'Assets Dashboard',
  'SIP-10',
  'NFTs',
  'Staking',
  'Contacts',
  'Asigna SDK',
];
const ProPlan = [
  'All Basic features',
  'Embedded Applications',
  'Email notifications',
  'Privacy mode',
  'Sub accounts',
  'Permissions',
  'Earn (Soon)',
  'Payments (Soon)',
];

export const useProPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState<Tabs>('Subscription');
  const [selectedPeriod, setSelectedPeriod] = useState<Period>('3 months');
  const [orders, setOrders] = useState<ISubscriptionOrder[] | undefined>();
  const [orderToPay, setOrderToPay] = useState<ISubscriptionOrder | undefined>();
  const { products, setProducts } = useProducts();
  const { periodOptions, minMonthPrice } = usePeriodOptions();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (products) {
      return;
    }
    getAllActiveProducts().then((res) => setProducts(res.sort((a, b) => a.period - b.period)));
  }, [products]);

  return useMemo(
    () => ({
      isLoading,
      setIsLoading,
      tabs,
      selectedTab,
      setSelectedTab,
      BasicPlan,
      ProPlan,
      periodOptions,
      selectedPeriod,
      setSelectedPeriod,
      minMonthPrice,
      orders,
      setOrders,
      orderToPay,
      setOrderToPay,
      products,
      isModalOpen,
      setIsModalOpen,
    }),
    [isLoading, selectedTab, selectedPeriod, orders, orderToPay, isModalOpen]
  );
};
